import { MarcheBpuUo } from './marche-bpu.model';

export class MarcheBpuRevision {
  constructor(
    public uuid: string = '',
    public dateRevision: string | null = null,
    public lignes: MarcheBpuUo[] = [],
    public nombreUosRevisees: number = 0,
    public referencesIgnorees: string[] = [],
    public dateCreation: string | null = null
  ) {}

  static adapt(item: any): MarcheBpuRevision {
    return new MarcheBpuRevision(
      item.uuid ?? '',
      item.dateApplication ?? null,
      (item.uos ?? []).map((l: any) => MarcheBpuUo.adapt(l)),
      item.nombreUosRevisees ?? 0,
      item.referencesIgnorees ?? [],
      item.dateCreation ?? null
    );
  }
}
